// Bootstrap components
import 'bootstrap/js/src/util';
import 'bootstrap/js/src/alert';
import 'bootstrap/js/src/button';
import 'bootstrap/js/src/carousel';
import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/modal';
import 'bootstrap/js/src/popover';
import 'bootstrap/js/src/scrollspy';
import 'bootstrap/js/src/tab';
import 'bootstrap/js/src/tooltip';

// Bootstrap Material Design components
import 'bootstrap-material-design/js/dropdown';

import 'bootstrap-material-design/js/ripples';
import 'bootstrap-material-design/js/text';
import 'bootstrap-material-design/js/textarea';
import 'bootstrap-material-design/js/select';
import 'bootstrap-material-design/js/radio';
import 'bootstrap-material-design/js/radioInline';
import 'bootstrap-material-design/js/checkbox';
import 'bootstrap-material-design/js/checkboxInline';